<template>
  <div class="knifedisk-main">
    <!-- 容器用于固定两张图片的位置关系 -->
    <div class="images-container">
      <div class="knifedis-image1">
        <img src="../../static/contact/blade1.png">
      </div>
      <div class="knifedis-image2">
        <img src="../../static/contact/blade2.png">
      </div>
      <div class="knifedis-text-content">
        <p class="knifedis-text-content-p">{{ $t('series.knife_desc') }}<br>{{ $t('series.knife_desc1') }}</p>
      </div>

      <div class="knifedis-text-content2">
        <p class="knifedis-text-content5">{{ $t('series.knife_desc2') }}<br>
          {{ $t('series.knife_desc3') }}<br>
          {{ $t('series.knife_desc4') }}<br>
          {{ $t('series.knife_desc5') }}<br>
          {{ $t('series.knife_desc6') }}
        </p>
        <p>{{ $t('series.knife_desc7') }}<br>
          {{ $t('series.knife_desc8') }}<br>
          {{ $t('series.knife_desc9') }}
        </p>
      </div>
      <img style="top:80%;position: relative; z-index: 3;" src="../../static/contact/blade3.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "KnifeDiskSuspersion",
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$i18n.locale === 'en') {
        let p = document.getElementsByClassName('knifedis-text-content-p');
        p[0].style.fontSize = '2em'
      }
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.knifedis-text-content2',
          start: 'top 85%',      // 进入视口的触发点
          end: 'bottom 15%',     // 离开视口的触发点
          markers: false,
          toggleActions: 'play none none none',
          once: true
        }
      });
      masterTimeline.to(['.knifedis-text-content', '.knifedis-text-content2'], {
        duration: 1.5,
        ease: 'power2.in',
        y: -170,
      }, 0.1)

      masterTimeline.to(['.knifedis-text-content5'], {
        duration: 1.5,
        ease: 'power2.in',
        color: '#ffffff',
      }, 0.1)

      masterTimeline.to('.knifedis-image2', {
        duration: 1.5,
        ease: 'power2.in',
        y: -50,
      }, 0.1)
    })
  }
}
</script>
<style scoped>
.knifedisk-main {
  background-color: black;
  height: 1000px;
  width: 95%;
  position: relative;
  overflow: hidden; /* 防止图片超出容器 */
  margin: 0 auto;
  margin-top: 400px;
}

/* 图片容器 - 固定宽度为屏幕的80% */
.images-container {
  position: absolute;
  /* 整体居中 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 占屏幕宽度的80% */
  width: 100%;
  height: 100%;
}

/* 第一张图片样式 - 设置透明度 */
.knifedis-image1 {
  position: absolute;
  width: 102%;
  height: 140%;
  margin-top: -365px;
  opacity: 0.5; /* 第一张图片透明度0.7 */

  img {
    width: 100%;
    height: 100%;
    object-fit: inherit; /* 保持比例并完整显示 */
  }
}

/* 第二张图片样式 - 在上层且完全重合 */
.knifedis-image2 {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2; /* 确保在第一张图片上方 */

  img {
    width: 102%;
    height: 140%;
    -o-object-fit: contain;
    object-fit: initial;
    margin-top: -478px;
  }
}

/* 第三张图片固定在images-container右侧且大小不变 */
.blade-three {
  position: absolute;
  /* 定位在images-container右侧 */
  left: 80%;
  top: 20%;
  /* 使用固定像素宽度确保大小不变 */
  width: 350px; /* 可根据实际需求调整这个值 */

  /* 添加间距 */
  margin-left: 10px;

  img {
    width: 110%;
    height: auto; /* 高度自动适应，保持图片比例 */
    object-fit: contain;
  }
}

.knifedis-text-content {
  position: absolute;
}

.knifedis-text-content {
  position: absolute;
  z-index: 999;
  width: 20.5%;
  right: 0;
  top: 60%;
}

.knifedis-text-content p {
  color: #61cbf4;
  font-size: 2.5em;
  text-align: left;
}

.knifedis-text-content2 {
  position: absolute;
  z-index: 999;
  width: 20.5%;
  right: 0;
  top: 73%;
}

.knifedis-text-content2 p {
  color: #808080;
  font-size: 1.2em;
  text-align: left;
  margin-bottom: 1px;
}

.knifedis-text-content2 p:nth-of-type(2) {
  color: #808080;
}


</style>

